module.exports = __webpack_public_path__ + "img/Feature.4628e248.png";